import type { ReactElement } from 'react'
import { PenLine } from 'lucide-react'
import { ProviderIcon } from '@renderer/components/provider-icon'
import type { WritingStyleIntegration } from '../use-writing-style-integrations'

interface WritingStyleIconProps {
  integration: WritingStyleIntegration
  size: number
}

export function WritingStyleIcon({ integration, size }: WritingStyleIconProps): ReactElement {
  if (integration.provider) {
    return <ProviderIcon provider={integration.provider} size={size} />
  }
  return <PenLine size={size} strokeWidth={1.5} />
}
